export default __webpack_public_path__ + "static/media/Christmas_21.2db90eb8.png";